module.exports = __webpack_public_path__ + "img/thumbnail_PrairieDog_f_albino.a1b49f4a.png";